import { useEffect, useState } from "react";
import { API_BASE, apiFetch } from "../api";

// Bank accounts (in assets) and credit cards, for the "Paid from" / "Received into"
// pickers on the desktop pages (the phone screens get them from useMobileData).
export const useMoneySources = () => {
  const [sources, setSources] = useState({ assets: [], cards: [] });
  useEffect(() => {
    Promise.all([
      apiFetch(`${API_BASE}/assets`).then((r) => (r.ok ? r.json() : [])),
      apiFetch(`${API_BASE}/credit-cards`).then((r) => (r.ok ? r.json() : [])),
    ])
      .then(([assets, cards]) => setSources({ assets, cards }))
      .catch(() => {});
  }, []);
  return sources;
};
